import Exposition from "./Exposition";
export default Exposition;
